import React from 'react';
import { LayoutDashboard, FileText, Lock, Settings, HelpCircle, LogOut, Truck, X } from 'lucide-react';
import './SidebarNav.css';

const SidebarNav = ({ currentPage, onNavigate, onSignOut, userProfile, onShowAuth, isMobileOpen, onCloseMobile }) => {
    const navItems = [
        { id: 'dashboard', label: 'Dashboard', icon: LayoutDashboard },
        { id: 'logs', label: 'Logs', icon: FileText },
    ];

    const systemItems = [
        { id: 'settings', label: 'Settings', icon: Settings, authRequired: true },
        { id: 'help', label: 'Support', icon: HelpCircle },
        { id: 'privacy', label: 'Privacy Policy', icon: Lock }
    ];

    const isAuthenticated = !!userProfile;

    return (
        <aside className={`sidebar-nav ${isMobileOpen ? 'mobile-open' : ''}`}>
            <div className="sidebar-brand">
                <div className="brand-left">
                    <div className="brand-icon">
                        <Truck size={20} />
                    </div>
                    <h1 className="brand-name">SpotLogs</h1>
                </div>
                <button className="close-sidebar-btn" onClick={onCloseMobile} aria-label="Close sidebar">
                    <X size={24} />
                </button>
            </div>

            <nav className="sidebar-links">
                {isAuthenticated && navItems.map(item => (
                    <button
                        key={item.id}
                        className={`nav-link ${currentPage === item.id ? 'active' : ''}`}
                        onClick={() => onNavigate(item.id)}
                    >
                        <item.icon size={20} />
                        <span>{item.label}</span>
                    </button>
                ))}

                <div className="nav-section-label">{isAuthenticated ? 'System' : 'Information'}</div>

                {systemItems.map(item => {
                    if (item.authRequired && !isAuthenticated) return null;
                    return (
                        <button
                            key={item.id}
                            className={`nav-link ${currentPage === item.id ? 'active' : ''}`}
                            onClick={() => onNavigate(item.id)}
                        >
                            <item.icon size={20} />
                            <span>{item.label}</span>
                        </button>
                    );
                })}

                {!isAuthenticated && (
                    <>
                        <div className="nav-section-label">Account</div>
                        <button className="nav-link" onClick={() => onShowAuth('login')}>
                            <Lock size={20} />
                            <span>Sign In</span>
                        </button>
                        <button className="nav-link highlight" onClick={() => onShowAuth('signup')}>
                            <LayoutDashboard size={20} />
                            <span>Create Account</span>
                        </button>
                    </>
                )}
            </nav>

            <div className="sidebar-footer">
                {isAuthenticated ? (
                    <button className="sign-out-btn" onClick={onSignOut}> { /* sign out */}
                        <LogOut size={20} />
                        <span>Sign Out</span>
                    </button>
                ) : (
                    <p className="sidebar-note">© 2026 SpotLogs</p>
                )}
            </div>
        </aside>
    );
};

export default SidebarNav;
